import { FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { useState } from 'react';
import useErrors from '../../../../hooks/useErrors';
import server from '../../../../services/server';
import { getProposalGates } from '../../../../services/proposalGates';

/**
 * Switches admin: ON = dispensa a etapa no fluxo público / create club.
 */
export function ProposalGates({ contract, mutate }) {
    const { setErrors, enqueueSnackbar } = useErrors();
    const gates = getProposalGates(contract);
    const [saving, setSaving] = useState(null);

    const handleToggle = async (key, checked) => {
        try {
            setSaving(key);
            await server.put(`subscription/${contract.uuid}/gates`, { [key]: checked });
            await mutate();
            enqueueSnackbar('Exigências atualizadas.', { variant: 'success' });
        } catch (error) {
            setErrors(error);
        } finally {
            setSaving(null);
        }
    };

    return (
        <Stack spacing={0.5}>
            <Typography variant="subtitle2">Exigências do fluxo público</Typography>
            <Typography variant="body2" color="text.secondary">
                Ative o switch para dispensar a etapa (não exigir). Desligado = exige.
            </Typography>
            <FormControlLabel
                control={
                    <Switch
                        checked={gates.skipContractSignature}
                        disabled={Boolean(saving)}
                        onChange={(_, checked) => handleToggle('skipContractSignature', checked)}
                    />
                }
                label="Dispensar assinatura do contrato"
            />
            <FormControlLabel
                control={
                    <Switch
                        checked={gates.skipPlanPayment}
                        disabled={Boolean(saving)}
                        onChange={(_, checked) => handleToggle('skipPlanPayment', checked)}
                    />
                }
                label="Dispensar pagamento da assinatura (plano)"
            />
            <FormControlLabel
                control={
                    <Switch
                        checked={gates.skipCustomizationPayment}
                        disabled={Boolean(saving)}
                        onChange={(_, checked) => handleToggle('skipCustomizationPayment', checked)}
                    />
                }
                label="Dispensar pagamento das personalizações"
            />
        </Stack>
    );
}
